import { render, staticRenderFns } from "./nzToggleSlim.vue?vue&type=template&id=33ec0f8a"
import script from "./nzToggleSlim.vue?vue&type=script&lang=js"
export * from "./nzToggleSlim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports